import React from "react";
import { observer } from "mobx-react";
import { Button } from "@components/buttons";

interface QuickPlayPopupsPaginationProps {
	onPrevClick: () => void;
	onNextClick: () => void;
	isDisabled: boolean;
	currentPage: number;
	totalPages: number;
}

export const QuickPlayPopupsPagination = observer(
	function QuickPlayPopupsPagination(props: QuickPlayPopupsPaginationProps) {
		return (
			<div className="popup__footer__row u-display--f--center">
				<Button
					type="button"
					disabled={props.isDisabled}
					onClick={props.onPrevClick}
					switchIcon
					loaderClassName="btn--load--primary"
					className="btn--square btn--square--med btn--primary--inverted"
					iconClassName="u-icon--tny u-icon--caret-left u-color--text--secondary"
					iconOnly
				/>

				<div className="popup__pager">
					{props.currentPage} / {props.totalPages}
				</div>
				<Button
					type="button"
					disabled={props.isDisabled}
					onClick={props.onNextClick}
					switchIcon
					loaderClassName="btn--load--primary"
					className="btn--square btn--square--med btn--primary--inverted"
					iconClassName="u-icon--tny u-icon--caret-right u-color--text--secondary"
					iconOnly
				/>
			</div>
		);
	}
);
